import type { LeagueContext } from '@api-service/league-context';

/**
 * - `open`: the poll is for the next gameweek, so members can vote.
 * - `closed`: the poll is for the gameweek whose deadline has just passed, so
 *   its final result shows until the editors publish the next week.
 * - `hidden`: any other gameweek, so a poll nobody updated never lingers.
 */
export type CaptaincyPollStatus = 'open' | 'closed' | 'hidden';

const PERCENT = 100;

export const getCaptaincyPollStatus = (
  pollGameweek: number,
  context: Pick<LeagueContext, 'currentGameweek' | 'nextGameweek'> | null
): CaptaincyPollStatus => {
  if (pollGameweek === context?.nextGameweek?.number) return 'open';
  if (pollGameweek === context?.currentGameweek?.number) return 'closed';
  return 'hidden';
};

/** A player's share of the votes as a whole percentage. */
export const toVoteShare = (votes: number, totalVotes: number) =>
  totalVotes === 0 ? 0 : Math.round((votes / totalVotes) * PERCENT);

export const DEFAULT_CAPTAINCY_POLL_QUESTION = (gameweek: number) =>
  `Who are you captaining in Gameweek ${gameweek}?`;
